export default __webpack_public_path__ + "static/media/1-4.522db523.jpg";